export const boxShadow1 = "0px 12px 19px rgba(51, 204, 153, 0.09)"

export const boxShadow2 = "0px 10px 25px rgba(183, 187, 214, 0.5)"

export const themeShadow = "0px 10px 25px rgba(51, 204, 153, 0.3)"

export const secondaryShadow = "0px 10px 19px rgba(0, 217, 205, 0.2)"
